import axios from "axios";
import { API, auth } from "./shared";

// Creation drafts live on the phone and on the server, so nothing typed is ever lost.
const KEY = "soulumo_simple_draft";
const URL_ = () => `${API}/api/audio-journeys/flow-draft/simple`;
const useful = (s) => s && (s.intent?.trim() || s.plan || s.listText?.trim());

export const loadSimpleDraft = async () => {
  let local = null;
  try { local = JSON.parse(localStorage.getItem(KEY) || "null"); } catch { /* corrupt */ }
  try {
    const s = (await axios.get(URL_(), auth())).data.draft?.state;
    if (useful(s) && (!useful(local) || (s.saved_at || "") >= (local.saved_at || ""))) return s;
  } catch { /* offline — use the phone copy */ }
  return useful(local) ? local : null;
};

export const saveSimpleDraftLocal = (state) => {
  try { localStorage.setItem(KEY, JSON.stringify(state)); } catch { /* storage full */ }
};
export const saveSimpleDraftServer = (state) => axios.put(URL_(), { state }, auth()).catch(() => {});

export const clearSimpleDraft = () => {
  localStorage.removeItem(KEY);
  axios.delete(URL_(), auth()).catch(() => {});
};
